var _path, _path2, _path3, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChartTypeMultipleLineIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M0 18V14L8.5 9.5L12.8333 11.8462L20 7.5V18H0Z",
    fill: "url(#paint0_linear_33930_132929)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 9.45895L12.8333 13.647L8.64444 11.2105L0 16.2632V13.7818L8.64444 8.74035L12.8333 11.2105L20 7V9.45895Z",
    fill: "var(--report-graph-bar-stack-color)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_33930_132929",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 2,
    width: 20,
    height: 10
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 4.45895L12.8333 8.64702L8.64444 6.21053L0 11.2632V8.78175L8.64444 3.74035L12.8333 6.21053L20 2V4.45895Z",
    fill: "#FF6D10"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_33930_132929)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: -3,
    width: 4,
    height: 18,
    fill: "#00B960"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: -3,
    width: 4,
    height: 18,
    fill: "#4891FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: -3,
    width: 4,
    height: 18,
    fill: "#FFB400"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: -3,
    width: 4,
    height: 18,
    fill: "#FF6D10"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: -3,
    width: 4,
    height: 18,
    fill: "#FF5082"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_33930_132929",
    x1: 10,
    y1: 9.5,
    x2: 10,
    y2: 18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartTypeMultipleLineIcon);
export default __webpack_public_path__ + "static/media/chart-type-multiple-line-icon.09eb03196c5815ecfac1a65fa4552ecd.svg";
export { ForwardRef as ReactComponent };